export const nav = {
    permissao: 'deck.horas:ver',
    section: 'Trabalho',
    title: 'Horas',
    icon: 'schedule',
    route: '/horas',
    sequence: 6,
};

export default [
    {
        path: '/horas',
        name: 'horas',
        component: () => import('./pages/FolhaPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.horas:ver' },
    },
    {
        path: '/horas/equipe',
        name: 'horas-equipe',
        component: () => import('./pages/FolhaDaEquipePage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.horas-equipe:ver' },
    },
];
